import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { RequestService } from 'src/app/shared/services/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class ResultadoFiltroService {
  constructor(private _requestService: RequestService) {}

  getSavedSearches(): Observable<any> {
    return this._requestService.requestMethod(
      `work/Search/RealEstate/ListSavedSearches`,
      'GET',
      true,
      null,
    );
  }

  getSavedSearchResult(searchId): Observable<any> {
    return this._requestService.requestMethod(
      `work/Search/RealState/SavedSearch/Filters?searchId=${searchId}`,
      'GET',
      true,
      null,
    );
  }

  resultadoBuscaSalvaIndustrial(
    buscaID: number,
    idSelecionado: number,
  ): Observable<any> {
    return this._requestService.requestMethod(
      `work/Search/IndustrialBuildingsInfrastructure/SavedSearch/Filters?searchId=${buscaID}&moduleID=${idSelecionado}`,
      'GET',
      true,
      null,
    );
  }

  submitFilterForm(data): Observable<any> {
    return this._requestService
      .requestMethod(
        `work/Search/RealEstate/ListWork/Filter`,
        'POST',
        true,
        data,
      )
      .pipe(
        catchError((error) => {
          console.error('Error submitting filter:', error);
          return throwError(() => new Error('Failed to submit filter.'));
        }),
      );
  }

  getActions(): Observable<any> {
    return this._requestService.requestMethod(
      `work/Actions`,
      'GET',
      true,
      null,
    );
  }

  getWorkResponsibles(): Observable<any> {
    return this._requestService.requestMethod(
      `work/Responsibles`,
      'GET',
      true,
      null,
    );
  }

  saveSearch(data): Observable<any> {
    return this._requestService
      .requestMethod(
        `work/Search/RealEstate/SaveWorkSearch`,
        'POST',
        true,
        data,
      )
      .pipe(
        catchError((error) => {
          console.error('Error saving search:', error);
          return throwError(() => new Error('Failed to save search.'));
        }),
      );
  }

  updateListing(update: any): Observable<any> {
    return this._requestService.requestMethod(
      `work/Search/RealState/UpdateSelected`,
      'PUT',
      true,
      update,
    );
  }

  downloadPDF(data): Observable<Blob> {
    const url = `work/worksDetails/exportPDF`;

    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/pdf',
    };

    return this._requestService.requestMethod(
      url,
      'POST',
      true,
      data,
      headers,
      'blob',
    );
  }

  printWorks(data): Observable<any> {
    const url = `work/worksDetails`;
    return this._requestService.requestMethod(url, 'POST', true, data);
  }

  editSavdSearchs(data): Observable<any> {
    return this._requestService.requestMethod(
      `work/EditSavedSearchesOfWorks`,
      'PUT',
      true,
      data,
    );
  }

  accessModules(companyID, restrictionKey) {
    let header = {
      'Content-Type': 'application/json',
      restrictionKey: restrictionKey != null ? restrictionKey : '',
      companyID: companyID != null ? companyID : '',
    };
    return this._requestService.requestMethod(
      `company/api/Company/GetContractedModules`,
      'GET',
      true,
      null,
      header,
    );
  }
}
